<template>
  <div class="container mb-4">
    <DataTable :value="INVOICE_DMTS" :autoLayout="true" sortField="title" :sortOrder="-1" :expander="true">
      <template #header>
        <div class="p-inputgroup">
          <span class="p-inputgroup-addon" style="color: black">
            DMT Värden
          </span>
        </div>
        <div class="p-d-flex mt-3">
            <Button label="Lägg till" icon="pi pi-plus" @click="addDMT" />
        </div>
      </template>
      <Column field="title" header="Beskrivning" />
      <Column field="data.dmtString" header="DMT Procent" bodyStyle="text-align: right"/>
      <Column field="data.dmt" header="DMT Multiplikator" bodyStyle="text-align: right"/>
        <template #footer>
          <div class="p-d-flex">
            <Button label="Lägg till" icon="pi pi-plus" @click="addDMT" />
          </div>
      </template>
    </DataTable>
    <Dialog :visible="newDMT" header="Lägg till ny DMT" :modal="true" autofocus v-on:update:visible="event => newDMT = event">
      <div class="p-field p-grid">
        <label for="title" class="p-col-fixed" style="width:150px">
          Beskrivning:
        </label>
        <div class="p-col">
          <InputText id="title" v-model.trim="newDMTValue.title" />
        </div>
      </div>
      <div class="p-field p-grid">
        <label for="dmtString" class="p-col-fixed" style="width:150px">
          DMT Procent:
        </label>
        <div class="p-col">
          <InputText id="dmtString" v-model="newDMTValue.data.dmtString" required="true" autofocus v-on:input="dmtStringInput($event)" />
        </div>
      </div>
      <div class="p-field p-grid">
        <span class="p-col-fixed" style="width:150px">
          DMT Multiplikator:
        </span>
        <div class="p-col">
          {{ newDMTValue.data.dmt }}
        </div>
      </div>
      <template #footer>
        <Button label="Spara" icon="pi pi-check" @click="saveDMT" />
      </template>
    </Dialog>
  </div>
</template>

<script>

import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Dialog from 'primevue/dialog'

import { mapGetters } from 'vuex'

export default {
  name: 'InvoiceDMT',
  components: {
    Button,
    InputText,
    DataTable,
    Column,
    Dialog
  },
  data () {
    return {
      newDMT: false,
      newDMTValue: this.resetNewDMT()
    }
  },
  async mounted () {
    await this.$store.dispatch('GET_INVOICE_DMTS')
  },
  computed: {
    ...mapGetters(['INVOICE_DMTS'])
  },
  methods: {
    resetNewDMT () {
      return {
        title: '',
        data: {
          dmt: 0,
          dmtString: ''
        },
        start: '',
        end: ''
      }
    },
    addDMT (event) {
      this.newDMT = true
    },
    dmtStringInput (event) {
      const val = event === '' ? '0' : event
      const fval = this._.replace(val, ',', '.')
      const comp = this._.split(fval, '.', 2)
      const precision = comp[1] === undefined ? 0 : comp[1].length
      this.newDMTValue.data.dmt = this._.round((100 + parseFloat(fval)) / 100, 2 + precision)
    },
    async saveDMT () {
      this.newDMTValue.data.dmtString = this._.replace(this.newDMTValue.data.dmtString, '.', ',')
      this.newDMTValue.data.dmtString += this._.endsWith(this.newDMTValue.data.dmtString, '%') ? '' : '%'
      await this.$store.dispatch('CREATE_INVOICE_DMT', this.newDMTValue)
      this.newDMT = false
      this.newDMTValue = this.resetNewDMT()
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Invoices/InvoiceDMT.vue